// extracted by mini-css-extract-plugin
module.exports = {"paper":"keto-paper_paper__fgu3M"};